import { AvailableThemes, TenantConfigTheme } from "../themes";

export enum TenantAppDomainEnum {
  EZZEBANK = "ezzebank.com",
  BANPRIME = "banprime.com.br",
  HUBCHAIN = "hubchain.com",
  GROOVEBANK = "groovebank.io",
}

export enum UsernameTypes {
  EMAIL = "EMAIL",
  CPF = "CPF",
  CPF_CNPJ = "CPF_CNPJ",
  EMAIL_CPF_CNPJ = "EMAIL_CPF_CNPJ",
}

export interface TenantConfigUsername {
  login: UsernameTypes;
  recoveryPassword: UsernameTypes;
}

export interface TenantConfigRoutes {
  dashboard: boolean;
}

export interface TenantContents {
  company: {
    shortName: string;
    fullName: string;
    documentNumber: string;
    address: {
      street: string;
      number: string;
      complement: string;
      neighborhood: string;
      city: string;
      state: string;
      postalCode: string;
    };
    centralService: {
      email: string;
      phone: string;
      description: string;
    };
    customerService: {
      email: string;
      phone: string;
      description: string;
    };
    ombudsmanService: {
      email: string;
      phone: string;
      description: string;
    };
    terms: {
      url: string;
    };
    privacy: {
      url: string;
    };
    dev: {
      url: string;
    };
    social: {
      twitter: string;
      instagram: string;
      whatsapp: string;
      facebook: string;
      lindkedin: string;
    };
  };
}

export interface TenantConfig {
  name: string;
  appDomain: TenantAppDomainEnum;
  theme: TenantConfigTheme;
  title: string;
  companyName?: string;
  favicon?: any;
  username: TenantConfigUsername;
  routes: TenantConfigRoutes;
  permissions: any[]; // PermissionType[];
  contents: TenantContents;
  stylesCss?: any;
}
